





























import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import Template from '@/views/reports/forms/traffic_sources/template.vue';


@Component({
  components: {
    Template,
  }
})

export default class ConfirmDialog extends Vue {
  @Prop({ default: {} })
  data: any;

  get title() {
    return this.data.title ||  this.t('Are you sure?')
  }

  get message() {
    return this.data.message || this.t('The changes will not be saved if you press OK.')
  }

  get cancelButtonIcon() {
    return this.data.cancelButtonIcon || 'fas fa-times'
  }

  get cancelButtonText() {
    return this.data.cancelButtonText || this.t('Cancel')
  }

  get confirmButtonText() {
    return this.data.confirmButtonText || this.t('OK')
  }

  get confirmButtonIcon() {
    return this.data.confirmButtonIcon || 'fas fa-check'
  }

  onCancel() {
    this.$emit('close')

    const { onCancel } = this.data
    onCancel && onCancel()
  }

  onConfirm() {
    this.$emit('close')

    const { onConfirm } = this.data
    onConfirm && onConfirm()
  }

}
